var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13326 10C5.21486 13.4421 7.67736 15 10.5 15C13.3227 15 15.7852 13.4421 17.8668 10C15.7852 6.55794 13.3227 5.00004 10.5 5.00004C7.67736 5.00004 5.21486 6.55794 3.13326 10ZM1.44318 9.58657C3.75604 5.53929 6.7667 3.33337 10.5 3.33337C14.2334 3.33337 17.244 5.53929 19.5569 9.58657C19.7033 9.84278 19.7033 10.1573 19.5569 10.4135C17.244 14.4608 14.2334 16.6667 10.5 16.6667C6.7667 16.6667 3.75604 14.4608 1.44318 10.4135C1.29677 10.1573 1.29677 9.84278 1.44318 9.58657ZM10.5 9.16671C10.0398 9.16671 9.66671 9.5398 9.66671 10C9.66671 10.4603 10.0398 10.8334 10.5 10.8334C10.9603 10.8334 11.3334 10.4603 11.3334 10C11.3334 9.5398 10.9603 9.16671 10.5 9.16671ZM8.00004 10C8.00004 8.61933 9.11933 7.50004 10.5 7.50004C11.8808 7.50004 13 8.61933 13 10C13 11.3808 11.8808 12.5 10.5 12.5C9.11933 12.5 8.00004 11.3808 8.00004 10Z",
    fill: "#DBFF00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.46ac42133176a633261bc02adec56b47.svg";
export { ForwardRef as ReactComponent };